import { createAction, props } from '@ngrx/store';

export const update = createAction('[Wishlist] Update', props< { wishlist: any } >());
